__turbopack_context__.v({
  "BGPattern": "SimpleSystem-module-scss-module__4uIpoq__BGPattern",
  "active": "SimpleSystem-module-scss-module__4uIpoq__active",
  "arrow": "SimpleSystem-module-scss-module__4uIpoq__arrow",
  "arrowLeft": "SimpleSystem-module-scss-module__4uIpoq__arrowLeft",
  "arrowRight": "SimpleSystem-module-scss-module__4uIpoq__arrowRight",
  "buttonDemo": "SimpleSystem-module-scss-module__4uIpoq__buttonDemo",
  "container": "SimpleSystem-module-scss-module__4uIpoq__container",
  "containerContent": "SimpleSystem-module-scss-module__4uIpoq__containerContent",
  "dot": "SimpleSystem-module-scss-module__4uIpoq__dot",
  "dotsWrapper": "SimpleSystem-module-scss-module__4uIpoq__dotsWrapper",
  "heading": "SimpleSystem-module-scss-module__4uIpoq__heading",
  "percentElement": "SimpleSystem-module-scss-module__4uIpoq__percentElement",
  "percentWrapper": "SimpleSystem-module-scss-module__4uIpoq__percentWrapper",
  "slider": "SimpleSystem-module-scss-module__4uIpoq__slider",
  "sliderContainer": "SimpleSystem-module-scss-module__4uIpoq__sliderContainer",
});
